import {useEffect, useState} from "react";
import {SwalAlertClass} from "core/swalClass";
import Form from "react-bootstrap/Form";

import {MiniQ2IndividualValuesModel, MiniQ2IndividualHasModel} from "./models/MiniQ2Models";
import {compareObjects} from "core/utils/objectUtils";
import RowTRComponentSwitch from "../../../components/RowTRComponentSwitch";
import RowTRComponentInput from "../../../components/RowTRComponentInput";

const MiniQ2FormS = ({item, t, type}) => {
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [values, setValues] = useState({...MiniQ2IndividualValuesModel});
    const [has, setHas] = useState({...MiniQ2IndividualHasModel});
    const styleCenterMiddle = {textAlign: "center", verticalAlign: "middle"};
    const styleThreshold = {minWidth: "60px"};

    useEffect(() => {
        if (!item.id) {
            setValues({...MiniQ2IndividualValuesModel});
            setHas({...MiniQ2IndividualHasModel});
        } else {
            setValues({...item.values});
            setHas({...item.has});
        }
    }, [item]);

    useEffect(() => {
        if (type) {
            if (compareObjects(item.values, MiniQ2IndividualValuesModel)) {
                setValues({...item.values});
                setHas({...MiniQ2IndividualHasModel, ...item.has});
            } else {
                setValues({...MiniQ2IndividualValuesModel});
                setHas({...MiniQ2IndividualHasModel});
            }
        }
    }, [type]);

    const onChangeValues = (e) => {
        let {name, value} = e.target;
        let values_ = {...values};
        values_[name] = parseInt(value);
        setValues({...values_});
    };

    const onChangeCheckHas = (e) => {
        let {name, checked} = e.target;
        name = name.replace("has-", "");
        let has_ = {...has};
        has_[name] = checked;
        setHas({...has_});
    };

    const onBlurValues = (e) => {
        const {title, name} = e.target;
        let value = parseInt(e.target.value);
        let min = parseInt(e.target.min);
        let max = parseInt(e.target.max);
        if (value < min || max < value) {
            Alert.warning(title, `El valor tiene que estar entre ${min}-${max}`);
            e.target.value = values[name];
            e.target.focus();
        }
    };

    return (
        <div className="row">
            <div className="col-12">
                <table className="table table-striped mb-5">
                    <thead>
                        <tr>
                            <th>{t("name")}</th>
                            <th>{t("description")}</th>
                            <th className="text-center">{t("parameters")}</th>
                            <th style={{width: "35px", textAlign: "center"}}>{t("actives")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{t("confsens.name")}</td>
                            <td>{t("confsens.description")}</td>
                            <td>
                                <div className="d-flex justify-content-end align-items-center">
                                    <label htmlFor="confsens" className="form-label me-2 mb-0">
                                        {t("confsens.name")}
                                    </label>
                                    <Form.Select
                                        className="mb-2"
                                        id="confsens"
                                        name="confsens"
                                        value={values.confsens}
                                        onChange={onChangeValues}
                                        style={{width: "120px"}}>
                                        <option value="0">{t("confsens.choice.a")}</option>
                                        <option value="1">{t("confsens.choice.b")}</option>
                                        <option value="2">{t("confsens.choice.ab")}</option>
                                    </Form.Select>
                                </div>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>{t("confdist.name")}</td>
                            <td>{t("confdist.description")}</td>
                            <td>
                                <div className="d-flex justify-content-end align-items-center">
                                    <label htmlFor="confdist" className="form-label me-2 mb-0">
                                        {t("confdist.name")}
                                    </label>
                                    <Form.Select
                                        className="mb-2"
                                        id="confdist"
                                        name="confdist"
                                        value={values.confdist}
                                        onChange={onChangeValues}
                                        style={{width: "120px"}}>
                                        <option value="0">{t("confdist.choice.c")}</option>
                                        <option value="1">{t("confdist.choice.l")}</option>
                                        <option value="2">{t("confdist.choice.cl")}</option>
                                    </Form.Select>
                                </div>
                            </td>
                            <td></td>
                        </tr>
                        <RowTRComponentInput
                            fieldName="saturation"
                            _TC={t}
                            valueIn={values.saturation}
                            styleCenterMiddle={styleCenterMiddle}
                            type="number"
                            deactivated={MiniQ2IndividualValuesModel.saturation}
                            inputProps={{
                                max: "255",
                                min: "1",
                                step: "1",
                            }}
                        />
                        <RowTRComponentSwitch
                            fieldName="hysteresis"
                            _TC={t}
                            valueIn={values.hysteresis}
                            hasIn={has.hysteresis}
                            setHasIn={onChangeCheckHas}
                            styleCenterMiddle={styleCenterMiddle}
                            type="number"
                            deactivated={0}
                        />

                        <tr>
                            <td colSpan="4" className="text-end">
                                {t("threshold.name.c")}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="text-center">
                                                <div>P0</div>
                                                <small className="text-muted fw-normal">17,4 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P1</div>
                                                <small className="text-muted fw-normal">22,53 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P2</div>
                                                <small className="text-muted fw-normal">27,66 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P3</div>
                                                <small className="text-muted fw-normal">32,79 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P4</div>
                                                <small className="text-muted fw-normal">43,05 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P5</div>
                                                <small className="text-muted fw-normal">53,31 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P6</div>
                                                <small className="text-muted fw-normal">63,57 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P7</div>
                                                <small className="text-muted fw-normal">73,83 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P8</div>
                                                <small className="text-muted fw-normal">84,09 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P9</div>
                                                <small className="text-muted fw-normal">94,35 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P10</div>
                                                <small className="text-muted fw-normal">104,61 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P11</div>
                                                <small className="text-muted fw-normal">infinito</small>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p0_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p0_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p1_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p1_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p2_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p2_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p3_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p3_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p4_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p4_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p5_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p5_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p6_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p6_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p7_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p7_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p8_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p8_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="255"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-255</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p9_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p9_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="255"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-255</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p10_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p10_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="255"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-255</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p11_threshold_s}
                                                    onChange={onChangeValues}
                                                    name="p11_threshold_s"
                                                    readOnly={values.confdist === 1}
                                                    max="255"
                                                    min="0"
                                                    step="1"
                                                    onBlur={onBlurValues}
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-255</small>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>

                        <tr>
                            <td colSpan="4" className="text-end">
                                {t("threshold.name.l")}
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th className="text-center">
                                                <div>P0</div>
                                                <small className="text-muted fw-normal">41,16 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P1</div>
                                                <small className="text-muted fw-normal">96,04 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P2</div>
                                                <small className="text-muted fw-normal">233,24 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P3</div>
                                                <small className="text-muted fw-normal">301,89 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P4</div>
                                                <small className="text-muted fw-normal">439,06 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P5</div>
                                                <small className="text-muted fw-normal">579,20 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P6</div>
                                                <small className="text-muted fw-normal">589,96 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P7</div>
                                                <small className="text-muted fw-normal">727,60 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P8</div>
                                                <small className="text-muted fw-normal">768,32 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P9</div>
                                                <small className="text-muted fw-normal">771,70 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P10</div>
                                                <small className="text-muted fw-normal">909,20 cm</small>
                                            </th>
                                            <th className="text-center">
                                                <div>P11</div>
                                                <small className="text-muted fw-normal">922,97</small>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p0_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p0_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p1_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p1_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p2_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p2_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p3_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p3_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p4_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p4_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p5_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p5_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p6_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p6_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p7_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p7_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="31"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-31</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p8_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p8_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="255"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-255</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p9_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p9_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="255"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-255</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p10_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p10_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="255"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-255</small>
                                            </td>
                                            <td className="text-center">
                                                <input
                                                    type="number"
                                                    className="form-control text-end"
                                                    value={values.p11_threshold_l}
                                                    onChange={onChangeValues}
                                                    name="p11_threshold_l"
                                                    readOnly={values.confdist === 0}
                                                    max="255"
                                                    min="0"
                                                    step="1"
                                                    style={styleThreshold}
                                                />
                                                <small className="text-muted">0-255</small>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default MiniQ2FormS;
